module.exports = {"version":"1.2.3.9"}


//////////////////
// WEBPACK FOOTER
// ./static/version.json
// module id = c+VB
// module chunks = 121